import { useEffect, useState } from 'react';
import { default as axios } from '../axiosConfig';
import { API_GetBannedUsers, API_UnbanUser } from '../Assets/ApiUrlContainer';

const BannedUsers = () => {
	const [bannedUsers, setBannedUsers] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchTerm, setSearchTerm] = useState(''); // Search term state

	useEffect(() => {
		fetchBannedUsers();
	}, []);

	const fetchBannedUsers = async () => {
		try {
			const response = await axios.get(API_GetBannedUsers, {
				withCredentials: true,
				headers: { 'Content-Type': 'application/json' },
			});

			console.log('Fetched Banned Users:', response.data);
			setBannedUsers(response.data);
		} catch (error) {
			console.error('Error fetching banned users:', error);
		}
	};

	const handleUnban = async (email) => {
		setLoading(true);
		try {
			const response = await axios.post(API_UnbanUser, { email }, {
				withCredentials: true,
				headers: { 'Content-Type': 'application/json' },
			});

			console.log(`Unban Response:`, response.data);
			fetchBannedUsers(); // Refresh list after action
		} catch (error) {
			console.error(`Error performing unban action:`, error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
			<h2 style={{ textAlign: 'center' }}>Blocked Users Management</h2>

			{bannedUsers.length == 0 && (
				<div className='noBannedUsers'>
					<p
						style={{
							fontSize: '1.25rem',
							textAlign: 'center',
							paddingTop: '2rem',
						}}
					>
						There are no users currently blocked from accessing the TGS portal.
					</p>
				</div>
			)}

			{bannedUsers.length > 0 && (
				<>
					{/* Search Bar */}
					<input
						type='text'
						placeholder='Search by name or email...'
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						style={{
							display: 'block',
							width: '100%',
							padding: '10px',
							marginBottom: '15px',
							borderRadius: '5px',
							border: '1px solid #ddd',
						}}
					/>

					{/* Refresh Button */}
					<button
						onClick={fetchBannedUsers}
						style={{
							marginBottom: '15px',
							padding: '10px 16px',
							cursor: 'pointer',
							backgroundColor: '#3498db',
							color: 'white',
							border: 'none',
							borderRadius: '5px',
							fontSize: '14px',
						}}
					>
						🔄 Refresh List
					</button>

					<table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
						<thead>
							<tr style={{ backgroundColor: '#f2f2f2', textAlign: 'left' }}>
								<th style={{ padding: '10px' }}>First Name</th>
								<th style={{ padding: '10px' }}>Last Name</th>
								<th style={{ padding: '10px' }}>Email</th>
								<th style={{ padding: '10px' }}>Actions</th>
							</tr>
						</thead>
						<tbody>
							{bannedUsers
								.filter(
									(user) =>
										user.FirstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
										user.LastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
										user.Email?.toLowerCase().includes(searchTerm.toLowerCase())
								)
								.map((user) => (
									<tr key={user.Email} style={{ borderBottom: '1px solid #ddd' }}>
										<td style={{ padding: '10px' }}>{user.FirstName || 'N/A'}</td>
										<td style={{ padding: '10px' }}>{user.LastName || 'N/A'}</td>
										<td style={{ padding: '10px' }}>{user.Email}</td>

										<td style={{ padding: '10px' }}>
											<button
												disabled={loading}
												onClick={() => handleUnban(user.Email)}
												style={{
													padding: '8px',
													backgroundColor: 'green',
													color: 'white',
													border: 'none',
													borderRadius: '5px',
													cursor: 'pointer',
												}}
											>
												Unblock
											</button>
										</td>
									</tr>
								))}
						</tbody>
					</table>
				</>
			)}
		</div>
	);
};

export default BannedUsers;
